import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { PayloadAction } from '../../../store.model';
import { EvaluationService } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../search.action';

import { RunSearch, runSearchResult } from './run-search.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const runSearch = (
    action: Observable<PayloadAction<ActionType, RunSearch>>,
) =>
    action.pipe(
        ofType(ActionType.EVAL_SEARCH__RUN_SEARCH),
        switchMap((act: PayloadAction<ActionType, RunSearch>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);

            return service.search(act.payload.params).pipe(
                map((ret) => {
                    return runSearchResult(
                        {
                            ...act.payload,
                            data: ret,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(runSearchResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );
